import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Image, ImageContainer } from './BKJImage.styled.js';
export function BKJImage({ alt, src = '', LoadingComponent, FallbackComponent, variant, ...rest }) {
    const [isLoading, setIsLoading] = useState(true);
    const [isFallbackDisplayed, setFallbackDisplayed] = useState(false);
    const [hideImage, setHideImage] = useState(true);
    const onError = useCallback(() => {
        setIsLoading(false);
        setFallbackDisplayed(true);
    }, []);
    const onLoad = useCallback(() => {
        setIsLoading(false);
        setHideImage(false);
    }, []);
    return (_jsxs(ImageContainer, { ...rest, children: [isLoading && _jsx(LoadingComponent, {}), isFallbackDisplayed ? (_jsx(FallbackComponent, {})) : (_jsx(Image, { hidden: isLoading || hideImage, borderRadius: variant === 'Round' ? '50%' : '0', src: src, alt: alt, onError: onError, onLoad: onLoad, ...rest }))] }));
}
//# sourceMappingURL=BKJImage.js.map